export class Random {
  /**
   * Generates a unique identifier.
   */
  public static generateId(): string {
    //TODO: generateId won't be needed after adding Typescript 4.6.x. crypto.randomUUID() should be used instead.
    return Math.random().toString(36).substring(2).concat(Date.now().toString());
  }
}
